import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ALERTS } from "@/data/mock";
import type { Alert } from "@/types";
import { withLatency } from "./simulate";

export async function fetchAlerts() {
  return withLatency([...ALERTS]);
}

export async function updateAlertStatus(id: string, status: Alert["status"]) {
  const index = ALERTS.findIndex((a) => a.id === id);
  if (index !== -1) {
    ALERTS[index] = { ...ALERTS[index], status };
  }
  return withLatency(index !== -1 ? ALERTS[index] : undefined, 180);
}

export function useAlerts() {
  return useQuery({ queryKey: ["alerts"], queryFn: fetchAlerts, staleTime: 30_000 });
}

export function useUpdateAlertStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: Alert["status"] }) => updateAlertStatus(id, status),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["alerts"] }),
  });
}
